/* unplugin-vue-components disabled */import script from "./more.vue?vue&type=script&setup=true&lang=ts"
export * from "./more.vue?vue&type=script&setup=true&lang=ts"

import "./more.vue?vue&type=style&index=0&id=3bb10d65&lang=scss"

const __exports__ = script;

export default __exports__